import { render, staticRenderFns } from "./product-category.view.vue?vue&type=template&id=47edb6a8&scoped=true&lang=pug"
import script from "./product-category.view.vue?vue&type=script&lang=ts"
export * from "./product-category.view.vue?vue&type=script&lang=ts"
import style0 from "./product-category.view.vue?vue&type=style&index=0&id=47edb6a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47edb6a8",
  null
  
)

export default component.exports